import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconGridLive$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconGridLive extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'edd34bb003788db77b3a8bc068c1c612a5e20bd3', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'c5257cf6944311d236a903bb8198c8ce3f15501c', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '8b769d5dfc173dd42ee87edf8c900286178659a4', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12.333 4.333a1.333 1.333 0 1 1-2.666 0 1.333 1.333 0 0 1 2.666 0m-1.333 8a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666M11 19a1.333 1.333 0 1 0 0-2.667A1.333 1.333 0 0 0 11 19m-6.667 0a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667m1.334-8A1.333 1.333 0 1 1 3 11a1.333 1.333 0 0 1 2.667 0M4.333 5.667a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667M19 11a1.333 1.333 0 1 1-2.667 0A1.333 1.333 0 0 1 19 11m-1.333 8a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-grid-live", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-grid-live"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-grid-live":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconGridLive$1);
            }
            break;
    } });
}

const CosmosIconGridLive = CosmosIconGridLive$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconGridLive, defineCustomElement };
